import { render, staticRenderFns } from "./BothView.vue?vue&type=template&id=366bf0d0&"
import script from "./BothView.vue?vue&type=script&lang=js&"
export * from "./BothView.vue?vue&type=script&lang=js&"
import style0 from "./BothView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports